const PURCHASE_STORAGE_KEY = 'gtm_fired_purchases';

/**
 * Check if a purchase event should be fired (not already tracked)
 */
export function shouldFirePurchase(transactionId: string): boolean {
  if (typeof window === 'undefined') return false;

  try {
    const stored = sessionStorage.getItem(PURCHASE_STORAGE_KEY);
    const firedPurchases: string[] = stored ? JSON.parse(stored) : [];
    return !firedPurchases.includes(transactionId);
  } catch {
    return true;
  }
}

/**
 * Mark a purchase as fired to prevent duplicate tracking
 */
export function markPurchaseFired(transactionId: string): void {
  if (typeof window === 'undefined') return;

  try {
    const stored = sessionStorage.getItem(PURCHASE_STORAGE_KEY);
    const firedPurchases: string[] = stored ? JSON.parse(stored) : [];

    if (!firedPurchases.includes(transactionId)) {
      firedPurchases.push(transactionId);
      sessionStorage.setItem(PURCHASE_STORAGE_KEY, JSON.stringify(firedPurchases));
    }
  } catch {
    // sessionStorage might be full or disabled
  }
}
